import { useEffect, useState } from 'react'
import { CreditCard, CheckCircle2, AlertTriangle, Copy, Link2 } from 'lucide-react'
import api from '../api/client'
import { successModal, errorModal } from '../components/ui'

export default function IntegracaoAsaas() {
  const [cfg, setCfg] = useState(null)
  const [apiKey, setApiKey] = useState('')
  const [sandbox, setSandbox] = useState(false)
  const [ativo, setAtivo] = useState(true)
  const [busy, setBusy] = useState(false)

  const load = () => api.get('/integracoes/asaas').then((r) => {
    setCfg(r.data); setSandbox(!!r.data.sandbox); setAtivo(!!r.data.ativo)
  }).catch(() => {})
  useEffect(() => { load() }, [])

  async function salvar() {
    setBusy(true)
    try {
      await api.post('/integracoes/asaas', { api_key: apiKey || undefined, sandbox, ativo })
      setApiKey(''); await load(); successModal('Configuração do ASAAS salva.')
    } catch (e) { errorModal(e?.response?.data?.detail || 'Erro ao salvar') } finally { setBusy(false) }
  }
  async function testar() {
    setBusy(true)
    try { const r = await api.post('/integracoes/asaas/testar'); successModal(`${r.data.mensagem} Ambiente: ${r.data.ambiente}. Saldo: R$ ${Number(r.data.saldo || 0).toFixed(2)}.`, { title: 'Conexão OK' }) }
    catch (e) { errorModal(e?.response?.data?.detail || 'Falha na conexão') } finally { setBusy(false) }
  }
  const copiar = (t) => { navigator.clipboard?.writeText(t); successModal('Copiado!') }

  if (!cfg) return <p className="text-gray-500">Carregando...</p>

  return (
    <div className="space-y-5 max-w-2xl">
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-sky-400 to-blue-500 flex items-center justify-center shadow"><CreditCard size={20} className="text-white" /></div>
        <div>
          <h1 className="text-2xl font-heading font-bold text-gray-900">Integração ASAAS</h1>
          <p className="text-sm text-gray-500">Gateway de pagamento — PIX, boleto e cartão. Cobranças e confirmação automática (webhook).</p>
        </div>
      </div>

      <div className={`rounded-2xl p-4 flex items-center gap-3 ${cfg.configurado ? 'bg-emerald-50 border border-emerald-200' : 'bg-amber-50 border border-amber-200'}`}>
        {cfg.configurado ? <CheckCircle2 className="text-emerald-600" size={20} /> : <AlertTriangle className="text-amber-600" size={20} />}
        <div className="text-sm">
          {cfg.configurado
            ? <>Chave configurada: <b>{cfg.api_key_mascarada}</b> · ambiente <b>{cfg.sandbox ? 'sandbox' : 'produção'}</b></>
            : <>Nenhuma chave configurada. Cole sua chave de API do ASAAS abaixo.</>}
        </div>
      </div>

      <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Chave de API do ASAAS</label>
          <input type="password" value={apiKey} onChange={(e) => setApiKey(e.target.value)} autoComplete="off"
            placeholder={cfg.configurado ? '•••••••• (deixe em branco p/ manter a atual)' : 'Cole aqui sua chave ($aact_...)'}
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-accent-400 font-mono" />
          <p className="text-[11px] text-gray-400 mt-1">A chave fica armazenada apenas no servidor e nunca é exibida em claro.</p>
        </div>
        <div className="flex items-center gap-6">
          <label className="flex items-center gap-2 text-sm text-gray-700"><input type="checkbox" checked={sandbox} onChange={(e) => setSandbox(e.target.checked)} className="w-4 h-4 accent-accent-500" /> Ambiente de testes (sandbox)</label>
          <label className="flex items-center gap-2 text-sm text-gray-700"><input type="checkbox" checked={ativo} onChange={(e) => setAtivo(e.target.checked)} className="w-4 h-4 accent-accent-500" /> Integração ativa</label>
        </div>
        <div className="flex gap-2">
          <button disabled={busy} onClick={salvar} className="rounded-xl bg-gradient-to-r from-primary-500 to-accent-500 text-white px-5 py-2 text-sm font-semibold shadow disabled:opacity-40">Salvar</button>
          <button disabled={busy || !cfg.configurado} onClick={testar} className="rounded-xl bg-white border border-gray-200 px-4 py-2 text-sm font-semibold hover:bg-gray-50 disabled:opacity-40">Testar conexão</button>
        </div>
      </div>

      <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
        <div className="flex items-center gap-2 text-gray-700 font-semibold mb-2"><Link2 size={16} /> Webhook de confirmação</div>
        <p className="text-sm text-gray-500 mb-2">Cadastre esta URL no painel do ASAAS (Configurações › Webhooks) para confirmar pagamentos automaticamente:</p>
        <div className="flex items-center gap-2">
          <code className="flex-1 bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 text-xs break-all">{cfg.webhook_url}</code>
          <button onClick={() => copiar(cfg.webhook_url)} className="p-2 rounded-lg border border-gray-200 hover:bg-gray-50"><Copy size={15} /></button>
        </div>
      </div>
    </div>
  )
}
